<template>
    <Transition name="slide-fade">
        <div
            v-if="state.mode !== 'off'"
            :style="notificationStyle"
            class="notification-container"
        >
            <p :class="`notification-${state.mode}`">
                {{ state.message }}
            </p>
            <p class="notification-description">
                {{ state.description }}
            </p>
        </div>
    </Transition>
</template>
<script>
    import useNotification from '@/composables/useNotification.js'
    import useCheckScreen from '@/composables/useCheckScreen.js'

    export default {
        name: 'Notification',
        computed: {
            notificationStyle: (self) =>
                self.screen.isMobile.value ? { padding: '48px 10px' } : {}
        },
        setup() {
            const { state } = useNotification()
            const { isMobile } = useCheckScreen()

            return {
                state,
                screen: {
                    isMobile
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .slide-fade-enter-active {
        transition: all 0.8s ease-out;
    }
    .slide-fade-leave-active {
        transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateX(100px);
        opacity: 0;
    }

    .notification-container {
        position: fixed;
        top: 50%;
        right: 0;
        z-index: 9999999999;
        max-width: 760px;
        border-radius: 15px;
        background: #262626;
        padding: 48px 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;

        p {
            margin-bottom: 0px;
        }

        .notification-success,
        .notification-error {
            max-width: 379px;
            text-align: center;
            text-wrap: wrap;
            font-family: Instrument Sans;
            font-size: 44px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -1.76px;
        }
        .notification-success {
            color: #198754;
        }
        .notification-error {
            color: #e23453;
        }

        .notification-description {
            max-width: 600px;
            color: #acacac;
            text-align: center;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
        }
    }
</style>
